import { render, staticRenderFns } from "./CrewWorkersTag.vue?vue&type=template&id=6bad7399"
import script from "./CrewWorkersTag.vue?vue&type=script&lang=js"
export * from "./CrewWorkersTag.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports